<script>
import resources from '../advanced/resources'

import { required } from 'vuelidate/lib/validators'

export default {
  name: 'agenda-search-speciality',
  data () {
    return {
      agenda: {
        location: {
          distance: null
        }
      }
    }
  },
  mixins: [resources],
  validations: {
    agenda: {
      speciality: {
        id: {
          required
        }
      }
    }
  }
}
</script>

<template lang="pug">
page
  h2(slot="title")
    span.first-line
      span.icon 
      |  Encontre um Profissional por Especialidade Médica
  .col-xs-12.content
    .container-fluid
      .row
        .nav-tabs-wrapper
          search-options
        .col-xs-12.white-bg
          .row
            .col-xs-12
              div.col-sm-10
                .form-group(style='padding:30px 0px;')
                  .row
                    .col-xs-12
                      .form-group
                        v-input(:status="$v.agenda.speciality.id.$error ? 'error' : null")
                          f-select(
                            v-model="agenda.speciality.id",
                            :options="specialityOptions",
                            name="search-speciality",
                            label="Especialidade Médica",
                            :searchable="true",
                            @selected="onSelectedSpeciality")

                      f-select-patient(
                        v-model="agenda.patient.id",
                        :value="agenda.patient.id",
                        label="Para quem é a Pesquisa ?",
                        :get-all="true",
                        :searchable="false",
                        @selected="onSelectedPatient"
                      )

                      f-select(
                        v-model="agenda.covenant_type",
                        :options="covenantTypeOptions",
                        label="Que tipo de Profissional deseja Encontrar?",
                        :searchable="false")

                      .form-group
                        .row
                          .col-xs-12
                            label Qual a faixa de valores desejada para a Consulta Particular ?
                          .col-xs-12.col-sm-4
                            f-numeric(
                               currency='R$',
                               separator="."
                               :precision="2",
                               v-model='agenda.price_start')

                          .col-xs-12.col-sm-4
                            f-numeric(
                               currency='R$',
                               separator="."
                               :precision="2",
                               v-model='agenda.price_end')
                      .form-group
                        f-select(
                          v-model="agenda.level_id",
                          :options="levelOptions",
                          label="Qual o nível de urgência")

                      .form-group(style='margin-top:30px;', v-if="agenda.level_id === 'others'")
                        .row
                          .col-xs-12.col-sm-4
                            label Data início
                            v-datepicker(
                              name="valid_to_end",
                              v-model="agenda.date_start",
                              :config='config')
                            //-f-date(label="Data início", v-model="agenda.date_start")

                          .col-xs-12.col-sm-4
                            label Data final
                            v-datepicker(
                              name="valid_to_end",
                              v-model="agenda.date_end",
                              :config='config')
                            //-f-date(label="Data fim", v-model="agenda.date_end")

                          .col-xs-12.col-sm-4
                            f-select(label="Período", v-model="agenda.period", :options="periodOptions")

                      .buttons-wrapper
                        button.btn.save(@click.prevent="doSearchBySpeciality()")
                          span.icon 
                          |  Encontrar Profissional
</template>
<style>
.AppInput {
  padding: 1em;
  border: 1px solid grey;
  border-radius: 0.25rem;
}

.AppInput.has-status-error {
  border-color: red;
}
</style>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/speciality/agenda.vue